import React from 'react';

// Convert question description to the image slug filename
const toSlug = (text) =>
  text.toLowerCase().replace(/'/g, '').replace(/\s+/g, '-');

const QuestionCard = ({ question, isSelected, onToggle }) => {
  const slug = toSlug(question.description);
  const imgSrc = `/images/questions/${slug}.webp`;

  return (
    <div
      onClick={onToggle}
      className={`
        relative rounded-xl overflow-hidden cursor-pointer transition-all duration-200 border-2 select-none
        ${isSelected
          ? 'border-blue-500 shadow-lg ring-2 ring-blue-300'
          : 'border-gray-200 hover:border-blue-300 hover:shadow-md'
        }
      `}
    >
      {/* Image */}
      <div className="relative w-full aspect-[3/2] bg-gray-100 overflow-hidden">
        <img
          src={imgSrc}
          alt={question.description}
          className="w-full h-full object-cover"
          onError={(e) => { e.currentTarget.style.display = 'none'; }}
          loading="lazy"
        />
        {/* Selected overlay */}
        {isSelected && (
          <div className="absolute inset-0 bg-blue-500 bg-opacity-20" />
        )}
        {/* Checkmark badge */}
        <div className={`
          absolute top-2 right-2 w-7 h-7 rounded-full flex items-center justify-center transition-all
          ${isSelected ? 'bg-blue-500' : 'bg-white bg-opacity-80 border-2 border-gray-300'}
        `}>
          {isSelected && (
            <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
            </svg>
          )}
        </div>
      </div>

      {/* Label */}
      <div className={`px-3 py-2.5 text-sm font-medium text-center leading-snug transition-colors
        ${isSelected ? 'bg-blue-50 text-blue-800' : 'bg-white text-gray-800'}
      `}>
        {question.description}
      </div>
    </div>
  );
};

export default QuestionCard;
